module.exports = __webpack_public_path__ + "img/404_img.a4a96401.svg";